import apiClient from './api-client';

const especialidadesService = {
    listar: async () => {
        try {
          const response = await apiClient.get('/especialidades');
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      obter: async (id) => {
        try {
          const response = await apiClient.get('/especialidades/:id');
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },

}

export default especialidadesService;